import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import Drawer from '@material-ui/core/Drawer';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import { setSidebarVisibility } from '../reducers/ui';

import Responsive from './Responsive';

export const DRAWER_WIDTH = 240;
export const CLOSED_DRAWER_WIDTH = 55;

const styles = theme => ({
    drawerPaper: {
        position: 'relative',
        // height: 200,
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        backgroundColor: '#262f3d',
        color: 'white',
        borderRight: 'none',
        marginTop: '48px',
        [theme.breakpoints.only('xs')]: {
            marginTop: 0,
            height: '100vh',
            position: 'inherit',
            //backgroundColor: theme.palette.background.default,
            backgroundColor: '#262f3d',
        },
        [theme.breakpoints.up('md')]: {
            border: 'none',
            marginTop: '48px',
        },
    },
});

// We shouldn't need PureComponent here as it's connected
// but for some reason it keeps rendering even though mapStateToProps returns the same object
class Sidebar extends PureComponent {
    componentWillMount() {
        const { width, setSidebarVisibility } = this.props;
        if (width !== 'xs' && width !== 'sm') {
            setSidebarVisibility(true);
        }
    }

    handleClose = () => this.props.setSidebarVisibility(false);

    toggleSidebar = () => this.props.setSidebarVisibility(!this.props.open);

    render() {
        const {
            children,
            classes,
            closedSize,
            open,
            setSidebarVisibility,
            size,
            width,
            ...rest
        } = this.props;

        return (
            <Responsive
                xsmall={
                    <Drawer
                        variant='temporary'
                        open={open}
                        PaperProps={{
                            className: classes.drawerPaper,
                            style: { width: size 
                            , height : '100%'},
                        }}
                        onClose={this.toggleSidebar}
                        {...rest}
                    >
                        {React.cloneElement(children, {
                            onMenuClick: this.handleClose,
                        })}
                    </Drawer>
                }
                small={
                    <Drawer
                        variant='permanent'
                        open={open}
                        PaperProps={{
                            className: classes.drawerPaper,
                            style: {
                                width: open ? size : closedSize,
                                height : '100%'
                            },
                        }}
                        onClose={this.toggleSidebar}
                        {...rest}
                    >
                        {React.cloneElement(children, {
                            dense: true,
                            onMenuClick: this.handleClose,
                        })}
                    </Drawer>
                }
                medium={
                    <Drawer
                        variant='permanent'
                        open={open}
                        PaperProps={{
                            className: classes.drawerPaper,
                            style: {
                                width: open ? size : closedSize,
                                height : '100%'
                            },
                        }}
                        onClose={this.toggleSidebar}
                        {...rest}
                    >
                        {React.cloneElement(children, { dense: true })}
                    </Drawer>
                }
            />
        );
    }
}

Sidebar.propTypes = {
    children: PropTypes.node,
    classes: PropTypes.object,
    closedSize: PropTypes.number,
    open: PropTypes.bool.isRequired,
    setSidebarVisibility: PropTypes.func.isRequired,
    size: PropTypes.number,
    width: PropTypes.string,
};

Sidebar.defaultProps = {
    size: DRAWER_WIDTH,
    closedSize: CLOSED_DRAWER_WIDTH,
};

const mapStateToProps = state => ({
    open: state.ui.sidebarOpen,
});

export default compose(
    connect(
        mapStateToProps,
        { setSidebarVisibility }
    ),
    withStyles(styles),
    withWidth({ resizeInterval: Infinity }) // used to initialize the visibility on first render
)(Sidebar);